import { IconProps } from 'src/utils/icon';

const AnnouncementIcon: React.FC<IconProps> = ({
  size = 1,
  fill = '#2c2a29',
}) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 30 26"
  >
    <path
      fill={fill}
      d="M28.333 9.388V1.625c0-.444-.363-1.625-1.666-1.625-.371 0-.74.12-1.041.356l-4.429 3.455A12.846 12.846 0 0113.333 6.5h-10C1.493 6.5 0 7.955 0 9.75v4.875c0 1.795 1.492 3.25 3.333 3.25L3.308 19.5a12.6 12.6 0 001.332 5.634c.27.543.86.866 1.479.866h5.535c1.357 0 2.171-1.515 1.35-2.567A6.363 6.363 0 0111.64 19.5c0-.564.085-1.107.23-1.625h1.462c2.847 0 5.64.955 7.864 2.689l4.428 3.454c.296.231.663.357 1.041.357 1.298 0 1.667-1.157 1.667-1.625v-7.763c.992-.564 1.667-1.6 1.667-2.8 0-1.2-.674-2.235-1.667-2.799zM11.654 24.375l-5.515-.002c-.772-1.551-1.164-3.158-1.165-4.849L5 17.9 5 17.875h5.173a7.553 7.553 0 00-.198 1.625c0 1.792.588 3.493 1.68 4.875zm-8.32-8.125c-.92 0-1.667-.73-1.667-1.625V9.75c0-.896.748-1.625 1.666-1.625h10v8.125h-10zm23.335 6.446a.247.247 0 01-.013.045l-4.418-3.446c-2.082-1.623-4.606-2.632-7.238-2.937V8.017c2.632-.305 5.156-1.314 7.238-2.937l4.42-3.448.005.002c.002 0 .003-.002.004-.008l.002 21.07z"
    />
  </svg>
);

export default AnnouncementIcon;
